import { useEffect } from "react";

// Lightweight JSON-LD injector. Renders nothing visually; writes a
// <script type="application/ld+json" data-jsonld="<id>"> into <head> so
// crawlers pick up structured data. Re-runs whenever `data` changes.
export const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return;
    const selector = `script[data-jsonld="${id}"]`;
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-jsonld", id);
      document.head.appendChild(el);
    }
    try {
      el.textContent = JSON.stringify(data);
    } catch {
      /* no-op */
    }
    return () => {
      const stale = document.head.querySelector(selector);
      if (stale) stale.remove();
    };
  }, [id, data]);

  return null;
};
